module.exports = __webpack_public_path__ + "assets/5af91f742e1a9c5f68dad3e0fcdbf2d6.png";